import { render, staticRenderFns } from "./VToggler.vue?vue&type=template&id=1024d55c&scoped=true&lang=pug&"
import script from "./VToggler.vue?vue&type=script&lang=js&"
export * from "./VToggler.vue?vue&type=script&lang=js&"
import style0 from "./VToggler.vue?vue&type=style&index=0&id=1024d55c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1024d55c",
  null
  
)

export default component.exports